import { IPlayUIState } from "../../api/api";

type RequiredKey = keyof IPlayUIState;

function validateInitState(state: IPlayUIState) {
  const required: RequiredKey[] = [
    "balance",
    "bet",
    "currency",
    "gameInformation",
    "moneyType",
    "moneyTypes"
  ];

  const keys = Object.keys(state);
  const errors = required.filter(key => !keys.includes(key));

  return errors;
}

export { validateInitState };
